var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "trellis-assets": "static-1.2299"
    },
    "depPathPrefixes": {
      "trellis-assets": "/trellis-assets/static-1.2299"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.34105",
    "project": "trellis-assets",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};